import React, { useMemo } from 'react';
import { TypedMemo } from '../../../common/types';
import { SMLSectionTabs } from '../../components/SMLSectionTabs/SMLSectionTabs';
import { pitchHeadMessages } from '../pitchHeadMessages';
import { pitchTabs, PitchTabScreen } from '../pitchTabs';

interface PitchTabRowProps {
  /** The tab on screen. */
  screen: PitchTabScreen;
}

/** The Campaigns · Contacts · Find · Community spots row under the Pitch title (design navigation-v2 d 4a). */
const PitchTabRowComponent: React.FC<PitchTabRowProps> = ({ screen }) => {
  const tabs = useMemo(() => pitchTabs(screen), [screen]);
  return <SMLSectionTabs tabs={tabs} ariaLabel={pitchHeadMessages.title} />;
};

export const PitchTabRow = TypedMemo(PitchTabRowComponent);
